'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _scrollmagic = require('scrollmagic');

var _scrollmagic2 = _interopRequireDefault(_scrollmagic);

require("scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap");

var GeneralAnims = (function () {
  function GeneralAnims() {
    _classCallCheck(this, GeneralAnims);

    this.controller = new _scrollmagic2['default'].Controller();

    this.initStandardTextAnims();
    this.initImportantTextAnims();

    this.parallaxImages();

    this.initStaggerContainerAnims();
  }

  _createClass(GeneralAnims, [{
    key: 'initStandardTextAnims',
    value: function initStandardTextAnims() {
      var standardTexts = document.querySelectorAll('.text-standard.animated');

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = standardTexts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var text = _step.value;

          var tween = new TweenMax.from(text, 1, {
            y: 20,
            autoAlpha: 0,
            ease: Power4.easeOut
          });

          var scene = new _scrollmagic2['default'].Scene({
            triggerElement: text,
            offset: -window.innerHeight / 3
          }).setTween(tween).addTo(this.controller);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator['return']) {
            _iterator['return']();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'initImportantTextAnims',
    value: function initImportantTextAnims() {
      var importantTexts = document.querySelectorAll('.text-important.animated');

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = importantTexts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var text = _step2.value;

          var tween = new TweenMax.from(text, 1, {
            y: 20,
            autoAlpha: 0,
            ease: Power4.easeOut
          });

          var scene = new _scrollmagic2['default'].Scene({
            triggerElement: text,
            offset: -window.innerHeight / 3
          }).setTween(tween).addTo(this.controller);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
            _iterator2['return']();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: 'parallaxImages',
    value: function parallaxImages() {
      var images = document.querySelectorAll('.parallax-image');

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = images[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var image = _step3.value;

          var tween = new TweenMax.to(image, 1, {
            y: image.getAttribute('data-offset') ? "-=" + image.getAttribute('data-offset') : 0
          });

          var trigger, offset;

          if (image.getAttribute('data-trigger')) {
            trigger = image.getAttribute('data-trigger');
          } else if (image.closest('section')) {
            trigger = image.closest('section');
          } else {
            trigger = image;
          }

          if (image.getAttribute('data-trigger-offset')) {
            offset = image.getAttribute('data-trigger-offset');
          } else {
            offset = -window.innerHeight / 2;
          }

          var scene = new _scrollmagic2['default'].Scene({
            triggerElement: trigger,
            duration: window.innerHeight,
            offset: offset
          }).setTween(tween).addTo(this.controller);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3['return']) {
            _iterator3['return']();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'initStaggerContainerAnims',
    value: function initStaggerContainerAnims() {
      var containers = document.querySelectorAll('.stagger-children');

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = containers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var container = _step4.value;

          var tween = new TweenMax.staggerFrom(container.children, 1, {
            autoAlpha: 0,
            y: 20
          }, 0.2);

          var scene = new _scrollmagic2['default'].Scene({
            triggerElement: container,
            offset: -window.innerHeight / 3
          }).setTween(tween).addTo(this.controller);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4['return']) {
            _iterator4['return']();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }]);

  return GeneralAnims;
})();

exports['default'] = GeneralAnims;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdG91cmhla2xhLnVsdHJhbm9pci5jb20vYXNzZXRzL3NjcmlwdHMvcGFydGlhbHMvZ2VuZXJhbC1hbmltcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7b0JBQWlCLE1BQU07Ozs7MkJBQ0MsYUFBYTs7OztRQUM5Qiw2REFBNkQ7O0lBRS9DLFlBQVk7QUFDbkIsV0FETyxZQUFZLEdBQ2hCOzBCQURJLFlBQVk7O0FBRTdCLFFBQUksQ0FBQyxVQUFVLEdBQUcsSUFBSSx5QkFBWSxVQUFVLEVBQUUsQ0FBQTs7QUFFOUMsUUFBSSxDQUFDLHFCQUFxQixFQUFFLENBQUE7QUFDNUIsUUFBSSxDQUFDLHNCQUFzQixFQUFFLENBQUE7O0FBRTdCLFFBQUksQ0FBQyxjQUFjLEVBQUUsQ0FBQTs7QUFFckIsUUFBSSxDQUFDLHlCQUF5QixFQUFFLENBQUE7R0FDakM7O2VBVmtCLFlBQVk7O1dBWVQsaUNBQUc7QUFDdkIsVUFBTSxhQUFhLEdBQUcsUUFBUSxDQUFDLGdCQUFnQixDQUFDLHlCQUF5QixDQUFDLENBQUE7Ozs7Ozs7QUFFMUUsNkJBQWlCLGFBQWEsOEhBQUU7Y0FBdkIsSUFBSTs7QUFDWCxjQUFJLEtBQUssR0FBRyxJQUFJLFFBQVEsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtBQUNyQyxhQUFDLEVBQUUsRUFBRTtBQUNMLHFCQUFTLEVBQUUsQ0FBQztBQUNaLGdCQUFJLEVBQUUsTUFBTSxDQUFDLE9BQU87V0FDckIsQ0FBQyxDQUFBOztBQUVGLGNBQUksS0FBSyxHQUFHLElBQUkseUJBQVksS0FBSyxDQUFDO0FBQ2hDLDBCQUFjLEVBQUUsSUFBSTtBQUNwQixrQkFBTSxFQUFFLENBQUUsTUFBTSxDQUFDLFdBQVcsR0FBRyxDQUFDO1dBQ2pDLENBQUMsQ0FDRCxRQUFRLENBQUMsS0FBSyxDQUFDLENBQ2YsS0FBSyxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQTtTQUN4Qjs7Ozs7Ozs7Ozs7Ozs7O0tBQ0Y7OztXQUVzQixrQ0FBRztBQUN4QixVQUFNLGNBQWMsR0FBRyxRQUFRLENBQUMsZ0JBQWdCLENBQUMsMEJBQTBCLENBQUMsQ0FBQTs7Ozs7OztBQUU1RSw4QkFBaUIsY0FBYyxtSUFBRTtjQUF4QixJQUFJOztBQUNYLGNBQUksS0FBSyxHQUFHLElBQUksUUFBUSxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO0FBQ3JDLGFBQUMsRUFBRSxFQUFFO0FBQ0wscUJBQVMsRUFBRSxDQUFDO0FBQ1osZ0JBQUksRUFBRSxNQUFNLENBQUMsT0FBTztXQUNyQixDQUFDLENBQUE7O0FBRUYsY0FBSSxLQUFLLEdBQUcsSUFBSSx5QkFBWSxLQUFLLENBQUM7QUFDaEMsMEJBQWMsRUFBRSxJQUFJO0FBQ3BCLGtCQUFNLEVBQUUsQ0FBRSxNQUFNLENBQUMsV0FBVyxHQUFHLENBQUM7V0FDakMsQ0FBQyxDQUNELFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FDZixLQUFLLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFBO1NBQ3hCOzs7Ozs7Ozs7Ozs7Ozs7S0FDRjs7O1dBRWMsMEJBQUc7QUFDaEIsVUFBTSxNQUFNLEdBQUcsUUFBUSxDQUFDLGdCQUFnQixDQUFDLGlCQUFpQixDQUFDLENBQUE7Ozs7Ozs7QUFFM0QsOEJBQWtCLE1BQU0sbUlBQUU7Y0FBakIsS0FBSzs7QUFDWixjQUFJLEtBQUssR0FBRyxJQUFJLFFBQVEsQ0FBQyxFQUFFLENBQUMsS0FBSyxFQUFFLENBQUMsRUFBRTtBQUNwQyxhQUFDLEVBQUUsS0FBSyxDQUFDLFlBQVksQ0FBQyxhQUFhLENBQUMsR0FBRyxJQUFJLEdBQUcsS0FBSyxDQUFDLFlBQVksQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDO1dBQ3BGLENBQUMsQ0FBQTs7QUFFRixjQUFJLE9BQU8sRUFBRSxNQUFNLENBQUE7O0FBRW5CLGNBQUksS0FBSyxDQUFDLFlBQVksQ0FBQyxjQUFjLENBQUMsRUFBRTtBQUN0QyxtQkFBTyxHQUFHLEtBQUssQ0FBQyxZQUFZLENBQUMsY0FBYyxDQUFDLENBQUE7V0FDN0MsTUFBTSxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsU0FBUyxDQUFDLEVBQUU7QUFDbkMsbUJBQU8sR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLFNBQVMsQ0FBQyxDQUFBO1dBQ25DLE1BQU07QUFDTCxtQkFBTyxHQUFHLEtBQUssQ0FBQTtXQUNoQjs7QUFFRCxjQUFJLEtBQUssQ0FBQyxZQUFZLENBQUMscUJBQXFCLENBQUMsRUFBRTtBQUM3QyxrQkFBTSxHQUFHLEtBQUssQ0FBQyxZQUFZLENBQUMscUJBQXFCLENBQUMsQ0FBQTtXQUNuRCxNQUFNO0FBQ0wsa0JBQU0sR0FBRyxDQUFFLE1BQU0sQ0FBQyxXQUFXLEdBQUcsQ0FBQyxDQUFBO1dBQ2xDOztBQUVELGNBQUksS0FBSyxHQUFHLElBQUkseUJBQVksS0FBSyxDQUFDO0FBQ2hDLDBCQUFjLEVBQUUsT0FBTztBQUN2QixvQkFBUSxFQUFFLE1BQU0sQ0FBQyxXQUFXO0FBQzVCLGtCQUFNLEVBQUUsTUFBTTtXQUNmLENBQUMsQ0FDRCxRQUFRLENBQUMsS0FBSyxDQUFDLENBQ2YsS0FBSyxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQTtTQUN4Qjs7Ozs7Ozs7Ozs7Ozs7O0tBQ0Y7OztXQUV5QixxQ0FBRztBQUMzQixVQUFNLFVBQVUsR0FBRyxRQUFRLENBQUMsZ0JBQWdCLENBQUMsbUJBQW1CLENBQUMsQ0FBQTs7Ozs7OztBQUVqRSw4QkFBc0IsVUFBVSxtSUFBRTtjQUF6QixTQUFTOztBQUNoQixjQUFJLEtBQUssR0FBRyxJQUFJLFFBQVEsQ0FBQyxXQUFXLENBQUMsU0FBUyxDQUFDLFFBQVEsRUFBRSxDQUFDLEVBQUU7QUFDMUQscUJBQVMsRUFBRSxDQUFDO0FBQ1osYUFBQyxFQUFFLEVBQUU7V0FDTixFQUFFLEdBQUcsQ0FBQyxDQUFBOztBQUVQLGNBQUksS0FBSyxHQUFHLElBQUkseUJBQVksS0FBSyxDQUFDO0FBQ2hDLDBCQUFjLEVBQUUsU0FBUztBQUN6QixrQkFBTSxFQUFFLENBQUUsTUFBTSxDQUFDLFdBQVcsR0FBRyxDQUFDO1dBQ2pDLENBQUMsQ0FDRCxRQUFRLENBQUMsS0FBSyxDQUFDLENBQ2YsS0FBSyxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQTtTQUN4Qjs7Ozs7Ozs7Ozs7Ozs7O0tBQ0Y7OztTQXBHa0IsWUFBWTs7O3FCQUFaLFlBQVkiLCJmaWxlIjoiL1VzZXJzL2JhYmUvV29yay90b3VyaGVrbGEudWx0cmFub2lyLmNvbS9hc3NldHMvc2NyaXB0cy9wYXJ0aWFscy9nZW5lcmFsLWFuaW1zLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGdzYXAgZnJvbSAnZ3NhcCc7XG5pbXBvcnQgU2Nyb2xsTWFnaWMgZnJvbSAnc2Nyb2xsbWFnaWMnXG5pbXBvcnQgXCJzY3JvbGxtYWdpYy9zY3JvbGxtYWdpYy91bmNvbXByZXNzZWQvcGx1Z2lucy9hbmltYXRpb24uZ3NhcFwiXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEdlbmVyYWxBbmltcyB7XG4gIGNvbnN0cnVjdG9yICgpIHtcbiAgICB0aGlzLmNvbnRyb2xsZXIgPSBuZXcgU2Nyb2xsTWFnaWMuQ29udHJvbGxlcigpXG5cbiAgICB0aGlzLmluaXRTdGFuZGFyZFRleHRBbmltcygpXG4gICAgdGhpcy5pbml0SW1wb3J0YW50VGV4dEFuaW1zKClcblxuICAgIHRoaXMucGFyYWxsYXhJbWFnZXMoKVxuXG4gICAgdGhpcy5pbml0U3RhZ2dlckNvbnRhaW5lckFuaW1zKClcbiAgfVxuXG4gIGluaXRTdGFuZGFyZFRleHRBbmltcyAoKSB7XG4gICAgY29uc3Qgc3RhbmRhcmRUZXh0cyA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoJy50ZXh0LXN0YW5kYXJkLmFuaW1hdGVkJylcblxuICAgIGZvciAodmFyIHRleHQgb2Ygc3RhbmRhcmRUZXh0cykge1xuICAgICAgdmFyIHR3ZWVuID0gbmV3IFR3ZWVuTWF4LmZyb20odGV4dCwgMSwge1xuICAgICAgICB5OiAyMCxcbiAgICAgICAgYXV0b0FscGhhOiAwLFxuICAgICAgICBlYXNlOiBQb3dlcjQuZWFzZU91dFxuICAgICAgfSlcblxuICAgICAgdmFyIHNjZW5lID0gbmV3IFNjcm9sbE1hZ2ljLlNjZW5lKHtcbiAgICAgICAgdHJpZ2dlckVsZW1lbnQ6IHRleHQsXG4gICAgICAgIG9mZnNldDogLSB3aW5kb3cuaW5uZXJIZWlnaHQgLyAzXG4gICAgICB9KVxuICAgICAgLnNldFR3ZWVuKHR3ZWVuKVxuICAgICAgLmFkZFRvKHRoaXMuY29udHJvbGxlcilcbiAgICB9XG4gIH1cblxuICBpbml0SW1wb3J0YW50VGV4dEFuaW1zICgpIHtcbiAgICBjb25zdCBpbXBvcnRhbnRUZXh0cyA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoJy50ZXh0LWltcG9ydGFudC5hbmltYXRlZCcpXG5cbiAgICBmb3IgKHZhciB0ZXh0IG9mIGltcG9ydGFudFRleHRzKSB7XG4gICAgICB2YXIgdHdlZW4gPSBuZXcgVHdlZW5NYXguZnJvbSh0ZXh0LCAxLCB7XG4gICAgICAgIHk6IDIwLFxuICAgICAgICBhdXRvQWxwaGE6IDAsXG4gICAgICAgIGVhc2U6IFBvd2VyNC5lYXNlT3V0XG4gICAgICB9KVxuXG4gICAgICB2YXIgc2NlbmUgPSBuZXcgU2Nyb2xsTWFnaWMuU2NlbmUoe1xuICAgICAgICB0cmlnZ2VyRWxlbWVudDogdGV4dCxcbiAgICAgICAgb2Zmc2V0OiAtIHdpbmRvdy5pbm5lckhlaWdodCAvIDNcbiAgICAgIH0pXG4gICAgICAuc2V0VHdlZW4odHdlZW4pXG4gICAgICAuYWRkVG8odGhpcy5jb250cm9sbGVyKVxuICAgIH1cbiAgfVxuXG4gIHBhcmFsbGF4SW1hZ2VzICgpIHtcbiAgICBjb25zdCBpbWFnZXMgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yQWxsKCcucGFyYWxsYXgtaW1hZ2UnKVxuXG4gICAgZm9yICh2YXIgaW1hZ2Ugb2YgaW1hZ2VzKSB7XG4gICAgICB2YXIgdHdlZW4gPSBuZXcgVHdlZW5NYXgudG8oaW1hZ2UsIDEsIHtcbiAgICAgICAgeTogaW1hZ2UuZ2V0QXR0cmlidXRlKCdkYXRhLW9mZnNldCcpID8gXCItPVwiICsgaW1hZ2UuZ2V0QXR0cmlidXRlKCdkYXRhLW9mZnNldCcpIDogMFxuICAgICAgfSlcblxuICAgICAgdmFyIHRyaWdnZXIsIG9mZnNldFxuXG4gICAgICBpZiAoaW1hZ2UuZ2V0QXR0cmlidXRlKCdkYXRhLXRyaWdnZXInKSkge1xuICAgICAgICB0cmlnZ2VyID0gaW1hZ2UuZ2V0QXR0cmlidXRlKCdkYXRhLXRyaWdnZXInKVxuICAgICAgfSBlbHNlIGlmIChpbWFnZS5jbG9zZXN0KCdzZWN0aW9uJykpIHtcbiAgICAgICAgdHJpZ2dlciA9IGltYWdlLmNsb3Nlc3QoJ3NlY3Rpb24nKVxuICAgICAgfSBlbHNlIHtcbiAgICAgICAgdHJpZ2dlciA9IGltYWdlXG4gICAgICB9XG5cbiAgICAgIGlmIChpbWFnZS5nZXRBdHRyaWJ1dGUoJ2RhdGEtdHJpZ2dlci1vZmZzZXQnKSkge1xuICAgICAgICBvZmZzZXQgPSBpbWFnZS5nZXRBdHRyaWJ1dGUoJ2RhdGEtdHJpZ2dlci1vZmZzZXQnKVxuICAgICAgfSBlbHNlIHtcbiAgICAgICAgb2Zmc2V0ID0gLSB3aW5kb3cuaW5uZXJIZWlnaHQgLyAyXG4gICAgICB9XG5cbiAgICAgIHZhciBzY2VuZSA9IG5ldyBTY3JvbGxNYWdpYy5TY2VuZSh7XG4gICAgICAgIHRyaWdnZXJFbGVtZW50OiB0cmlnZ2VyLFxuICAgICAgICBkdXJhdGlvbjogd2luZG93LmlubmVySGVpZ2h0LFxuICAgICAgICBvZmZzZXQ6IG9mZnNldFxuICAgICAgfSlcbiAgICAgIC5zZXRUd2Vlbih0d2VlbilcbiAgICAgIC5hZGRUbyh0aGlzLmNvbnRyb2xsZXIpXG4gICAgfVxuICB9XG5cbiAgaW5pdFN0YWdnZXJDb250YWluZXJBbmltcyAoKSB7XG4gICAgY29uc3QgY29udGFpbmVycyA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoJy5zdGFnZ2VyLWNoaWxkcmVuJylcblxuICAgIGZvciAodmFyIGNvbnRhaW5lciBvZiBjb250YWluZXJzKSB7XG4gICAgICB2YXIgdHdlZW4gPSBuZXcgVHdlZW5NYXguc3RhZ2dlckZyb20oY29udGFpbmVyLmNoaWxkcmVuLCAxLCB7XG4gICAgICAgIGF1dG9BbHBoYTogMCxcbiAgICAgICAgeTogMjBcbiAgICAgIH0sIDAuMilcblxuICAgICAgdmFyIHNjZW5lID0gbmV3IFNjcm9sbE1hZ2ljLlNjZW5lKHtcbiAgICAgICAgdHJpZ2dlckVsZW1lbnQ6IGNvbnRhaW5lcixcbiAgICAgICAgb2Zmc2V0OiAtIHdpbmRvdy5pbm5lckhlaWdodCAvIDNcbiAgICAgIH0pXG4gICAgICAuc2V0VHdlZW4odHdlZW4pXG4gICAgICAuYWRkVG8odGhpcy5jb250cm9sbGVyKVxuICAgIH1cbiAgfVxufVxuIl19